import { render, staticRenderFns } from "./PagePayoutRequests.vue?vue&type=template&id=6a7209be&"
import script from "./PagePayoutRequests.vue?vue&type=script&lang=ts&"
export * from "./PagePayoutRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports